<template>
	<div><span class="biaoti">提现管理</span>
	<el-tabs type="border-card">
		<el-tab-pane label="用户管理">
			<el-form ref="form" :model="so" label-width="80px" style="margin-left: 80px;margin-top: 10px;">
				<el-form-item label="申请时间">					
					<el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="提现单号">
					<el-input v-model="so.dingdanhao"></el-input>
				</el-form-item>
				<el-form-item label="会员信息">
					<el-input v-model="so.guanjianci" placeholder="可搜索昵称"></el-input>
				</el-form-item>
				<el-form-item label="状态">
					<el-select v-model="so.zhuangtai" placeholder="请选择状态" style="width: 100%;">
						<el-option label="不限" value=""></el-option>
						<el-option label="待审核" value="0"></el-option>
						<el-option label="待打款" value="10"></el-option>
						<el-option label="已打款" value="20"></el-option>
						<el-option label="无效" value="5"></el-option>
					</el-select>
				</el-form-item>
			
				<el-form-item>
					<el-button type="info" @click="CSH" size="small">搜索</el-button>
					<el-button type="primary" size="small">导出Excle</el-button>
				</el-form-item>
			</el-form>
			<div style="width: 100%;background: #f7fafa;color: #788188;height: 2.5rem;font-size: 12px;line-height: 2.5rem;text-indent:25px">总数:<span>00</span></div>
			<el-table :data="shu" style="width: 100%; margin-left: 10px;">
				<el-table-column prop="dingdanhao" label=" 提现单号" width="120"/>				
				<el-table-column  label="会员信息" width="250">
					<template slot-scope="shu">
						<el-avatar shape="square" :src="shu.row.touxiang"></el-avatar>
						<span style="position:absolute; top:1.25rem; left: 3.75rem;color: #428bca;">{{shu.row.nicheng}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="_tixianfangshi" label="提现方式" width="100"/>				
				<el-table-column prop="shenqingjine" label="申请余额" width="120"/>				
				<el-table-column prop="jin_e" label="到账金额" width="120"/>				
				<el-table-column prop="shouxufei" label="手续费" width="120"/>				
				<el-table-column prop="shenqingshijian" label="申请时间" width="220"/>
				<el-table-column prop="_zhuangtai" label="状态">
					<el-tag type="danger" effect="dark"  size="small">待审核</el-tag>
					<el-tag type="info" effect="dark" v-show="zhuantai" size="small">无效</el-tag>
					<el-tag type="success" effect="dark" v-show="zhuantai" size="small">已打款</el-tag>
					<el-tag type="warning" effect="dark" v-show="zhuantai" size="small">待打款</el-tag>
				</el-table-column>
				<el-table-column prop="_zhuangtai" label="操作">
					<el-button size="samll">详情</el-button>
				</el-table-column>
			</el-table>
			<el-pagination layout="total,prev,pager,next,jumper" :total="zongshu" :page-size="jitiao"  :current-page.sync="ye" @current-change="Fenye" style="margin-top: 30px;"/>
			
		</el-tab-pane>
		<!-- <el-tab-pane label="提现设置"> -->
			<!-- <el-form ref="form" :model="tixian_peizhi" label-width="100px" style="margin-top: 10px;">
				<el-form-item label="提现手续费">
					<el-input v-model="tixian_peizhi.shouxufei"></el-input>
				</el-form-item>
				<el-form-item label="满多少提现">
					<el-input v-model="tixian_peizhi.qiti" placeholder="满多少提现"></el-input>
				</el-form-item>
				<el-form-item label="开启自动提现">
					<el-radio-group v-model="tixian_peizhi.zidongtixian" style="margin-left: 20px;">
						<el-radio label="0">关闭</el-radio>
						<el-radio label="1">开启</el-radio>						
					</el-radio-group>
				</el-form-item>
				<el-form-item>
					<el-button type="danger" @click="Peizhi(1)">提交</el-button>
				</el-form-item>
			</el-form> -->
		<!-- </el-tab-pane> -->
	</el-tabs>
	</div>
</template>

<script>
	let that;
	export default {
		data() {
			return {
				so: {},
				ye:1,
				jitiao:20,
				shu:[],
				zongshu:0,					
			    quan:{},
				tixian_peizhi:{},
				// 1021
				zhuantai:0,
				value1:''
			};
		},
		created(){
				that=this; 
				that.CSH();
				that.Peizhi();
		},
		methods: {
			CSH(){
				that.so.ye=that.ye;
				that.so.jitiao=that.jitiao;
				this.$post('k=tixian',that.so,function(s){
					that.shu=s.shu.lie;
					that.zongshu=Number(s.shu.zongshu);
				}); 
			},
			Fenye(e){
				that.ye=e;
				that.CSH();				
			},
			Shanchu(e){
				this.$confirm('确认删除?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'
				        }).then(() => {
					  that.shu.splice(e.$index,1);
					  this.$post('k=quan&c=shandian',{id:e.row.id},function(s){
						if(s.shi!=1){
							that.$xiaoxi(s.shu);
						}
					  }); 
				});				
			},
			Peizhi(e){
				if(e){
					that.$post('k=peizhi&c=tixian',that.tixian_peizhi,function(s){
						that.$xiaoxi(s.shu)
					});						
				}else{
				   that.$post('k=peizhi',{shui:'tixian'},function(s){
						if(s.shi===1){						
							that.tixian_peizhi=s.shu;
						}
				   });	
				}				
			}	
		}
	}
</script>

<style>
	.biaoti {
		display: block;
		width: 100%;
		text-indent: 10px;
		margin-bottom: 16px;
		font-size: 20px;
		color: #788188;
	}
</style>
